module.exports = __webpack_public_path__ + "static/media/smhc-scale-intro.c5bc0508.png";